import React, { useEffect, useState } from 'react';
import {
  Wrapper,
  Inside,
  Title,
  Logo,
  TimeWrapper,
  Time,
} from './Header.styles';
import logo from '../../assets/images/logo.svg';
import { getDateString, getTimeString } from '../../utils/datetime';

const Header = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Wrapper>
      <Inside>
        <Title to='/'>
          <span>Digitale</span>
          <br />
          Gästemappe
        </Title>

        <Logo to='/'>
          <img src={logo} alt='Hausboot Niederrhein' />
        </Logo>

        <TimeWrapper>
          <Time>{getTimeString(time)}</Time>
          <Time>{getDateString(time)}</Time>
        </TimeWrapper>
      </Inside>
    </Wrapper>
  );
};

export default Header;
